// extracted by mini-css-extract-plugin
export default {"consortiumTlrForm":"consortiumTlrForm---q_RnO","notification":"notification---e6P7U"};